import React from 'react'
import honesty from "../../img/honesty.png"
import learning from "../../img/learning.png"
import feedback from "../../img/feedback.png"
import trustworthy from "../../img/trustworthy.png"
import customer from "../../img/customer.png"
import transparency from "../../img/transparency.png"
import ownership from "../../img/ownership.png"
import improvement from "../../img/improvement.png"

export default function Value() {
    return (
        <div className='p-14 text-center'>
            <div className='mb-20'>
                <h1 className='md:text-6xl text-center text-3xl font-semibold my-5'>
                Our Values
                </h1>
                <h3 className='md:text-3xl text-xl font-medium'>
                Our core beliefs serve as a solid framework for our goal and obligation
                to transform the counseling landscape in India.
                </h3>
            </div>
            <div className='grid lg:grid-cols-4 grid-cols-2 gap-6'>
                <Values
                    image={honesty}
                    desc='Honesty'
                />
                <Values
                    image={learning}
                    desc='Learning'
                />
                <Values
                    image={feedback}
                    desc='Feedback'
                />
                <Values
                    image={trustworthy}
                    desc='Trustworthy'
                />
                <Values
                    image={customer}
                    desc='Customer'
                />
                <Values
                    image={transparency}
                    desc='Transparency'
                />
                <Values
                    image={ownership}
                    desc='Ownership'
                />
                <Values
                    image={improvement}
                    desc='Improvement'
                />
            </div>
        </div>
    );
}

function Values(props) {
    return (
        <div className='card py-2 bg-red-100 grid grid-cols-2 hover:bg-red-300 hover:text-stone-50'>
            <img src={props.image} className='w-20 bg-rose-200 rounded-full py-4 m-4 hover:bg-red-100'/>
            <p className='py-10 text-lg '>{props.desc}</p>
        </div>
    )
}